<template>
  <div v-show="authorized">
    <div class="breadcrumb" style="display: flex; flex-wrap: wrap; flex-flow: row-reverse">
        <router-link :to="{ path: '/admin' }">Main</router-link>

        <span v-for="(subOrgan, index) in organ.split('.')" :key="`${subOrgan}, ${index}`">
          <router-link :to="{ path: '/admin' + organ.split('.').slice(0, index + 1).join('.') }">{{ subOrgan }}</router-link>&nbsp;&lt;&nbsp;
        </span>

        <template  v-if="totalFrames">
          &nbsp;>&nbsp;
        <span  v-for="index in (totalFrames || 0)" :key="index">
          <router-link :to="{ path: '/admin' + organ + '\\' + index + '\\' + totalFrames }">{{ index }}</router-link>&nbsp;
        </span>
        </template>
    </div>

    <div class="mainDiv">
      <div class="">
        اندام‌های تعریف شده
        <table class="organListTable" cellpadding="2px">
          <tr v-for="(area, index) in areaList" :key="`${area}, ${index}`">
            <td @click="selectAreaByIndex(index)" :title="area.title">{{ area.name }} &nbsp;</td>
            <td v-if="area.hasChild"><img style="width: 25px" src="/img/goToDown.png" @click="goDown(area)" /></td>
            <td ><img style="width: 25px" src="/img/delete.png" @click="removeArea(index)"></td>
          </tr>
        </table>
      </div>
      <div class="">
      <table>
          <tr title="این نام در آدرس دیده می‌شود همچنین برای نامگذاری فایلهای مربوطه به کار می‌رود">
            <td style="text-align: left">نام (لاتین)</td>
            <td><input v-model="activeArea.name"/></td>
          </tr>
          <tr title="نام اصلی که توسط کاربر مشاهده می‌شود">
            <td style="text-align: left" >عنوان (فارسی)</td>
            <td><input ref="title" v-model="activeArea.title"/></td>
          </tr>
          <tr>
            <td colspan="2">توضیحات داخل اطلاعات</td>
          </tr>
          <tr>
            <td colspan="2" title="در صورت نیاز می‌توانید از توضیحات مجزا در فایلی به نام این ارگان و پسوند .txt استفاده کنید"><textarea id="description" rows="3" cols="30" style="width: 100%" v-model="activeArea.description"></textarea></td>
          </tr>
          <tr style="display: none">
            <td colspan="2">Separated Description</td>
            <td></td>
          </tr>
          <tr style="display: none">
            <td colspan="2" title="Separated description store on a separated text file"><textarea rows="5" cols="30" v-model="activeArea.separatedDescription"></textarea></td>
          </tr>
          <tr title="در غیر اینصورت کاربر فقط توضیحات -و در صورت وجود تصویر شماتیک- آن را می‌تواند ببیند">
            <td><label for="hasChild" >دارای زیر مجموعه است؟</label></td>
            <td><input type="checkbox" id="hasChild" v-model="activeArea.hasChild"/>
            </td>
          </tr>
          <tr v-show="activeArea.hasChild">
            <td><label>تعداد فریم‌ها (در صورت وجود)</label></td>
            <td><input type="number" style="width: 40px" v-model="activeAreaTotalFrames" dir="ltr"/>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <button class="btn success" @click="newArea()">اندام جدید</button>
              <button class="btn default" @click="save()" :disabled="!saveEnabled">ذخیره</button>
              <button class="btn warning" @click="undo()" :disabled="backupHistory.length === 0" title="لغو آخرین تغییر انجام شده">برگردان
              </button>
            </td>
          </tr>
          <tr>
            <td colspan="2">
              <button class="btn danger" @click="scaleAll()" title="در صورت تغییر ابعاد تصویر اصلی، نقاط تنظیم شده را نیز به همان نسبت می‌توانید تغییر دهید">تغییر مقیاس</button>
              <button class="btn info" @click="selectRestartPoint()" title="در صورتی که اندام بیش از یک بخش دارد، بخش جدید را می‌توانید با نقطه شروع مشخص کنید">نقطه شروع</button>
            </td>
          </tr>
        </table>
      </div>
      <div class="" style="">
        <template v-if="data.guide1">
          <h3>راهنمای یک</h3>
          <label v-if="data.guide1.x">X<input type="text" style="width:70px" v-model="data.guide1.x" dir="ltr" /></label>
          <label v-if="data.guide1.y">Y<input type="text" style="width:70px" v-model="data.guide1.y" dir="ltr" /></label>
          <br />
          <label>لینک</label><input type="text" style="width:190px" v-model="data.guide1.link" dir="ltr"
                                    title="با تعیین مسیر در این قسمت، کاربر با کلیک بر روی تصویر راهنما به مسیر مشخص شده هدایت می‌شود."
                                    placeholder="Brain.MRI.Coronal"/>
        </template>
        <template v-if="data.guide2">
          <h3>راهنمای دو</h3>
          <label v-if="data.guide2.x">X<input type="text" style="width:70px" v-model="data.guide2.x" dir="ltr" /></label>
          <label v-if="data.guide2.y">Y<input type="text" style="width:70px" v-model="data.guide2.y" dir="ltr" /></label>
          <br />
          <label>لینک</label><input type="text" style="width:190px" v-model="data.guide2.link" dir="ltr"
                                    title="با تعیین مسیر در این قسمت، کاربر با کلیک بر روی تصویر راهنما به مسیر مشخص شده هدایت می‌شود."
                                    placeholder="Brain.MRI.Sagital"/>
        </template>
      </div>
      <div class="">
        <label>اطلاعات</label><br />
        <textarea rows="10" cols="30" style="direction: ltr" v-model="dataForDisplay" title="معمولا نیازی به تغییر در این قسمت ندارید."></textarea>
      </div>
      <div class="">
      <file-upload :saveUrl="saveImageUrl"  title="تصویر اصلی"></file-upload>
      <file-upload :saveUrl="saveGuide1Url" title="راهنما یک"></file-upload>
      <file-upload :saveUrl="saveGuide2Url" title="راهنما دو"></file-upload>
      </div>
      <div class="description" style="width: 350px">
        <label>توضیحات فایل خارجی</label>
        <button class="highlight" title="Highlight" @click="editorHighlight">H</button>
        <button class="bold" title="Bold" @click="editorBold">B</button>
        <button class="link" title="Link" @click="editorLink">L</button>
        <button class="cleanup" title="Cleanup HTML tags" @click="editorCleanup">C</button>
        <textarea id="externalDescription" ref="editor" rows="10" cols="30" style="width: 100%" v-model="externalDescription"> ></textarea>
        <div class="description" v-html="markdown(externalDescription)"></div>
        <div v-show="savedDescription">
          <span style="color:gray">توضیح ذخیره شده در سرور:</span>
        <div class="description" v-html="savedDescription"></div>
        </div>
        <button class="btn success" @click="saveExternalDescription()" :disabled="!externalDescriptionChanged">ذخیره</button>
      </div>

      <div class="guide" v-bind:style="guide1Style" title="تصویر راهنمای سمت راست تصویر اصلی. با یک کلیک موقعیت خط افقی و با کلیک بعدی موقعیت خط عمودی مشخص می‌شود ">
        <img ref="guide1Line" class="guideLine" style="position: absolute" v-bind:style="guide1LineStyle"  @click="guide1Click"/>
        <img ref="guide1Image" :src="guide1Path" @click="guide1Click" onerror="this.style.display='none'" @load="guide1Loaded"/>
      </div>
      <div class="guide" v-bind:style="guide2Style" title="تصویر راهنمای سمت چپ تصویر اصلی. با یک کلیک موقعیت خط افقی و با کلیک بعدی موقعیت خط عمودی مشخص می‌شود ">
        <img ref="guide2Image" :src="guide2Path" style="position: relative" @click="guide2Click" onerror="this.style.display='none'" @load="guide2Loaded"/>
        <img ref="guide2Line" class="guideLine" style="position: absolute" v-bind:style="guide2LineStyle"  @click="guide2Click"/>
      </div>

      <div class="">
        <img ref="img" style="display: none;" :src="imagePath"/>
        <canvas ref="canvas"
                v-bind:title="activeArea.title"
                @mousedown="mouseDown"
                @mouseup="mouseUp"
                @mousemove="mouseMove"
                :style="'cursor: ' + canvasCursor"
        ></canvas>
        <br />
        <span>فلش ماوس
        <label>بعلاوه<input type="radio" value="crosshair" v-model="canvasCursor" /></label>
        <label>خالی<input type="radio" value="none" v-model="canvasCursor" /></label>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Organ from './Organ'
import FileUpload from './FileUpload'
export default {
  extends: Organ,
  name: 'designer',
  components: {FileUpload},
  data () {
    return {
      authorized: false,
      externalDescription: null,
      externalDescriptionOriginal: null,
      savedDescription: null,
      saveUrl: process.env.saveUrl || '',
      // saveUrl: 'http://localhost:5050',
      backupHistory: [],
      saveEnabled: false,

      overPoint: null,
      mode: null, // can be 'drag', 'restartPoint'

      pointSize: 2,
      strokeStyle: 'darkgrey',
      fillStyle: '#fff',
      guide1Style: {},
      guide2Style: {},
      canvasCursor: 'crosshair'
    }
  },
  computed: {
    basePath () {
      return '/data/'
    },
    organPath () {
      return this.basePath + this.organ.replace(/\./g, '/')
    },
    imagePath () {
      if (this.frame) {
        return this.organPath + `/${this.frame}.jpg`
      } else {
        return this.organPath + '/image.jpg'
      }
    },
    dataPath () {
      if (this.frame) {
        return this.organPath + `/${this.frame}.json`
      } else {
        return this.organPath + '/data.json'
      }
    },
    saveImageUrl () {
      return this.saveUrl + '/upload.php?filePath=' + this.imagePath.replace(this.basePath, '')
    },
    saveGuide1Url () {
      return this.saveUrl + '/upload.php?filePath=' + this.organPath.replace(this.basePath, '') + '/guide-1.jpg'
    },
    saveGuide2Url () {
      return this.saveUrl + '/upload.php?filePath=' + this.organPath.replace(this.basePath, '') + '/guide-1.jpg'
    },
    dataForDisplay: {
      get () { return JSON.stringify(this.data, null, 2) },
      set (val) { this.backup(); this.data = JSON.parse(val); this.redraw(); this.saveEnabled = true }
    },
    activeAreaTotalFrames: {
      get () { if (this.activeArea.frames) return this.activeArea.frames.split('\\')[2] },
      set (val) { this.activeArea.frames = val ? `\\1\\${val}` : undefined }
    },
    externalDescriptionChanged () {
      return this.externalDescription !== this.externalDescriptionOriginal
    }
  },
  watch: {
    organ (newValue) {
      this.clearBackup()
      this.loadDataAndRedraw()
    },
    frame (newValue) {
      this.clearBackup()
      this.loadDataAndRedraw()
    }
  },
  mounted: function () {
    // let password = prompt('Enter Access password')
    // let hash = 0
    // for (let i in password) {
    //   hash += password[i] * 1
    // }
    // this.authorized = (hash === 48 || hash === 43) && (password.length === 11)
    this.authorized = true
    this.canvasCursor = localStorage.getItem('canvas.cursor') || 'crosshair'
  },
  beforeRouteUpdate (to, from, next) {
    if (this.canChangeOrgan()) {
      next()
    }
    // react to route changes...
    // don't forget to call next()
  },
  methods: {
    backup () {
      if (this.status !== 'loading') {
        this.backupHistory.push(JSON.parse(JSON.stringify(this.data)))
        this.saveEnabled = true
      }
    },
    clearBackup () {
      this.backupHistory = []
    },
    canChangeOrgan () {
      if (this.externalDescriptionChanged) {
        return confirm('توضیحات تغییر کرده است. خروج بدون ذخیره‌سازی؟')
      }
      return true
    },
    undo () {
      let lastData = this.backupHistory.pop()
      this.data.areaList = lastData.areaList
      this.data.guide1 = lastData.guide1
      this.data.guide2 = lastData.guide2
      this.redraw()
    },
    designerClickLocation (area) {
      return '/admin' + this.clickLocation(area)
    },
    drawNodes (area) {
      let context = this.context
      let firstPoint = true
      for (let point of area.points) {
        context.beginPath()
        context.arc(point.x, point.y, this.pointSize, 0, 2 * Math.PI)
        if (firstPoint) {
          context.strokeStyle = 'rgb(0, 0, 255)'
          firstPoint = false
        } else {
          context.strokeStyle = 'rgb(255, 0, 0)'
        }
        context.stroke()
      }
      context.strokeStyle = 'rgb(0, 255, 150)'
      context.stroke()
    },
    getAreaFillStyle (area) {
      let isSelected = area === this.activeArea
      if (isSelected) {
        return 'rgba(100, 100, 255, 0.3'
      } else {
        return 'rgba(200, 200, 255, 0.05)'
      }
    },
    getAreaStrokeStyle (area) {
      let isSelected = area === this.activeArea
      if (isSelected) {
        return 'green'
      }
      return 'rgba(100, 200, 100, 0.5)'
    },
    selectAreaByIndex (index) {
      if (!this.canChangeOrgan()) {
        return
      }
      this.activeAreaIndex = index
      this.redraw()
      this.loadExternalDescription()
    },
    loadExternalDescription () {
      this.externalDescription = ''
      this.externalDescriptionOriginal = ''
      let organ = this
      axios(this.descriptionNoCachePath()).then(response => {
        organ.externalDescription = response.data
        organ.externalDescriptionOriginal = response.data
        if (!(organ.activeArea.title) && organ.externalDescription !== '') {
          let firstLine = organ.externalDescription.split('\n')[0]
          if (firstLine.length < 50) {
            organ.backup()
            organ.activeArea.title = firstLine
          }
        }
      })
    },
    save (forceSave) {
      this.data.areaList = this.areaList
      let url = this.saveUrl + '/save.php?filePath=' + this.dataPath.replace(this.basePath, '')
      if (forceSave) {
        url += `&force_save=${forceSave}`
      }
      this.status = 'saving'
      let organ = this
      axios.post(url, this.data)
        .then(function (response) {
          organ.status = null
          organ.clearBackup()
          organ.saveEnabled = false
          console.log(response)
        }).catch(function (r) {
          let response = r.response
          organ.status = null
          if (response.status === 417) {
            if (confirm(response.data)) {
              organ.save(true)
            }
          } else {
            alert('خطا در ذخیره سازی: ' + response.data || r.message)
          }
        })
      localStorage.setItem('canvas.cursor', this.canvasCursor)
    },
    saveExternalDescription (forceSave) {
      if (this.activeArea.description) {
        if (confirm('این ناحیه دارای توضیحات داخلی است. در اینصورت توضیحات ازفایل خارجی بارگذاری نخواهد شد.' +
            'توضیحات داخلی پاک شود؟')) {
          this.backup()
          this.activeArea.description = ''
        }
      }
      let saveDescriptionUrl = this.metaDataPath.replace(this.basePath, '//')
      saveDescriptionUrl = `${this.saveUrl}/save.php?filePath=${saveDescriptionUrl}/${this.activeArea.name}.txt`
      if (forceSave) {
        saveDescriptionUrl += `&force_save=${forceSave}`
      }
      let organ = this
      if (this.externalDescription) {
        axios.post(saveDescriptionUrl, this.externalDescription, forceSave).then(function (response) {
          organ.externalDescriptionOriginal = organ.externalDescription
          // organ.savedDescription = response.data
          console.log(response)
        }).catch(function (r) {
          let response = r.response
          organ.status = null
          if (response.status === 417) {
            if (confirm(response.data)) {
              organ.saveExternalDescription(true)
            }
          } else {
            alert('خطا در ذخیره سازی: ' + response.data || r.message)
          }
        })
      }
    },
    newArea () {
      if (!this.canChangeOrgan()) {
        return
      }
      let name = prompt('نام اندام جدید را وارد کنید')
      if (name) {
        this.backup()
        this.data.areaList.push({'name': name, 'points': []})
        this.activeAreaIndex = this.areaList.length - 1
        this.redraw()
        this.loadExternalDescription()
        this.$refs.title.focus()
      }
    },
    newLine () {

    },
    removeArea (index) {
      this.backup()
      this.areaList.splice(index, 1)
      this.redraw()
    },
    removePoint (index) {
      this.backup()
      this.activeArea.points.splice(index, 1)
      this.redraw()
    },
    matchPoints (checkPoint, mousePoint) {
      if (mousePoint.x > checkPoint.x + this.pointSize) {
        return false
      }

      if (mousePoint.x < checkPoint.x - this.pointSize) {
        return false
      }

      if (mousePoint.y > checkPoint.y + this.pointSize) {
        return false
      }

      if (mousePoint.y < checkPoint.y - this.pointSize) {
        return false
      }
      return true
    },
    dragPoint (selectedPoint, newPoint) {
      this.activeArea.points.map((pointToMove) => {
        if (pointToMove.x === selectedPoint.x && pointToMove.y === selectedPoint.y) {
          pointToMove.x = newPoint.x
          pointToMove.y = newPoint.y

          this.redraw()
        }
      })
    },
    mouseUp (event) {
      let mouseUpPoint = this.getMousePos(event)
      if (this.mode === 'drag' && this.overPoint) {
        this.dragPoint(this.overPoint, mouseUpPoint)
        this.mode = null
      } else if (this.mode === null) {
        this.addNode(mouseUpPoint)
      } else if (this.mode === 'restartPoint') {
        this.backup()
        this.overPoint.restart = true
        this.mode = null
        this.redraw()
      }
    },
    mouseMove (event) {
      let point = this.getMousePos(event)
      if (this.mode === 'drag' && this.overPoint) {
        this.dragPoint(this.overPoint, point)
      }
    },
    mouseDown (event) {
      let point = this.getMousePos(event)
      let isMouseOnNode = this.isMouseOnNode(point)
      if (isMouseOnNode && this.mode === null) {
        this.backup()
        this.mode = 'drag'
      }
    },
    isMouseOnNode (point) {
      return this.selectedPoint(point) !== null
    },
    selectedPoint (point) {
      for (let iteratedPoint of this.activeArea.points || []) {
        if (this.matchPoints(iteratedPoint, point)) {
          this.overPoint = iteratedPoint
          return iteratedPoint
        }
      }
      this.overPoint = null
      return null
    },
    addNode (point) {
      if (this.activeArea.points) {
        this.backup()
        this.activeArea.points.push(point)
        this.redraw()
      }
    },
    goDown (area) {
      if (area) {
        if (!this.canChangeOrgan()) {
          return
        }
        let location = this.designerClickLocation(area)
        this.$router.push(location)
      }
    },
    scaleArea (area, factorX, factorY) {
      if (factorY === undefined) {
        factorY = factorX
      }
      for (let point of area.points) {
        point.x = Math.round(point.x * factorX)
        point.y = Math.round(point.y * factorY)
      }
    },
    scaleAll () {
      let scaleFactor = prompt('ضریب تغییر را وارد کنید (یک یعنی بدون تغییر)', 1)
      if (!scaleFactor) return
      this.backup()
      for (let area of this.areaList) {
        this.scaleArea(area, scaleFactor, scaleFactor)
        this.redraw()
      }
    },
    selectRestartPoint () {
      alert('بر روی نقطه مورد نظر کلیک کنید. این نقطه شروع محیط جدید برای ترسیم خواهد بود.')
      this.mode = 'restartPoint'
    },
    guideClick (evt, guide) {
      this.backup()
      guide = guide || {}
      let rect = evt.target.getBoundingClientRect()
      let image = guide === this.data.guide1 ? this.$refs.guide1Image : this.$refs.guide2Image
      let mouseUpPoint = {
        x: parseInt(1000 * (evt.clientX - rect.left) / image.width) / 10,
        y: parseInt(1000 * (evt.clientY - rect.top) / image.height) / 10
      }
      if (guide.x === undefined) {
        guide.x = `${mouseUpPoint.x}%`
        guide.y = undefined
      } else {
        guide.x = undefined
        guide.y = `${mouseUpPoint.y}%`
      }
      return guide
    },
    checkErrors () {
      if (this.$refs.guide1Image.naturalHeight !== this.$refs.guide2Image.naturalHeight) {
        alert('اخطار. ارتفاع دو تصویر راهنما با هم برابر نیستند')
      }
      if (this.$refs.guide1Image.naturalWidth !== this.$refs.guide2Image.naturalWidth) {
        alert('اخطار. عرض دو تصویر راهنما با هم برابر نیستند')
      }
    },
    guide1Click (event) {
      this.$set(this.data, 'guide1', this.guideClick(event, this.data.guide1))
    },
    guide1Loaded (event) {
      this.guide1Style.display = ''
      this.guide1Style.height = `${this.$refs.guide1Image.naturalHeight}px`
    },
    guide2Click (event) {
      this.$set(this.data, 'guide2', this.guideClick(event, this.data.guide2))
    },
    guide2Loaded (event) {
      this.guide2Style.display = ''
      this.guide2Style.height = `${this.$refs.guide2Image.naturalHeight}px`
    },
    editorSelectedStart () {
      let txtarea = this.$refs['editor']
      let start = txtarea.selectionStart
      let finish = txtarea.selectionEnd
      let value = txtarea.value
      if (start === finish) {
        while (start >= 1 && value[start - 1] !== ' ') {
          start--
        }
      }
      return start
    },
    editorSelectedFinish () {
      let txtarea = this.$refs['editor']
      let start = txtarea.selectionStart
      let finish = txtarea.selectionEnd
      let value = txtarea.value
      if (start === finish) {
        while (finish <= value.length && value[finish] !== ' ') {
          finish++
        }
      }
      return finish
    },
    editorSelectedWord (replaceStr) {
      let txtarea = this.$refs['editor']
      let start = this.editorSelectedStart()
      let finish = this.editorSelectedFinish()
      let value = txtarea.value
      return value.substr(start, finish - start)
    },
    editorApplyClass (replaceStr) {
      console.log('apply ' + replaceStr)
      let txtarea = this.$refs['editor']
      let start = this.editorSelectedStart()
      let finish = this.editorSelectedFinish()
      let value = txtarea.value
      let selectedWord = value.substr(start, finish - start)
      replaceStr = replaceStr.replace('{v}', selectedWord)
      this.externalDescription = `${value.substr(0, start)}${replaceStr}${value.substr(finish, value.length)}`
    },
    editorHighlight () {
      this.editorApplyClass('*{v}*')
    },
    editorBold () {
      this.editorApplyClass('**{v}**')
    },
    findAreaByTitle (title) {
      for (let area of this.areaList) {
        if (area.title === title) {
          return area
        }
      }
      return null
    },
    editorLink () {
      let selectedOrgan = this.editorSelectedWord()
      let selectedArea = this.findAreaByTitle(selectedOrgan)
      console.log('link')
      if (selectedArea) {
        selectedOrgan = selectedArea.name
      } else {
        alert(`ارگانی با عنوان '${selectedOrgan}' در این صفحه پیدا نشد.`)
      }
      let link = prompt('link', '#' + this.organ + '#' + selectedOrgan)
      if (link) {
        this.editorApplyClass(`[{v}](${link})`)
      }
    },
    editorCleanup () {
      let txtarea = this.$refs['editor']
      let s = txtarea.value
      s = s.replace(new RegExp(/<.*?>/, 'g'), '')
      s = s.replace(new RegExp('&nbsp;', 'g'), '')
      s = s.replace(new RegExp('&zwnj;', 'g'), '‌')
      this.externalDescription = s
    }
  }
}
</script>
<style scoped>
.mainDiv {
  display: flex;
  flex-wrap: wrap
}
.mainDiv div {
  margin: 5px;
}
canvas {
  border: 1px solid #fbb;
  /* cursor: crosshair; */
  /*width: 100%;*/
}
.canvasHolder {
  overflow: scroll;
}
.organListTable {
  direction: ltr;
  background-color: #9acfea;
  color: #1a1a1a;
  margin: 10px;
  cursor: pointer;
  border-radius: 5px;
  width: 220px;
}
.organListTable td {
  padding-left: 5px;
  width: 32px;
  height: 30px;
}

.goDown {
  background: url('/img/goToDown.png') left top no-repeat;
}
.delete {
  background: url('/img/delete.png') left top no-repeat;
}
#description {
  background-color: #ff8487;
}

.guide {
  position: relative;
}
.guide img {
  width: 100%;
}

textarea {
  font-family: Verdana,Arial,Helvetica,sans-serif;
  font-size: 14px;
}
.description .cleanup {
  text-decoration: line-through;
}
.description .description {
  text-align: justify;
  height: 250px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/OrganDesigner.vue